import { toDateInputValue } from '@/shared/utils/date-input';
import type { EventOption } from '../../../../types/campaigns.types';

/**
 * The day an event stops being promotable — its end date, or its start date
 * for single-day events that carry no end. Null when neither parses.
 */
function effectiveEndDate(evt: EventOption): string | null {
  return toDateInputValue(evt.endDate) ?? toDateInputValue(evt.startDate);
}

/**
 * True once an event has finished. The events endpoint returns everything the
 * org has ever published — it filters on `live`/`deleted`, never on dates — so
 * the picker has to work out for itself what is still worth promoting.
 */
export function hasEventEnded(evt: EventOption, today: string): boolean {
  const end = effectiveEndDate(evt);
  if (!end) return false;
  return end < today;
}

/**
 * Order events for the dropdown: soonest first, so the event an organizer is
 * most likely promoting is one click away. Events we can't date sort first
 * rather than being buried. Assumes ended events have already been excluded.
 */
export function sortEventsForPicker(events: EventOption[]): EventOption[] {
  return [...events].sort((a, b) => {
    const aStart = toDateInputValue(a.startDate) ?? '';
    const bStart = toDateInputValue(b.startDate) ?? '';
    if (aStart === bStart) return a.name.localeCompare(b.name);
    return aStart.localeCompare(bStart);
  });
}
